// src/features/services/components/ServiceCustomerSection.tsx
import type { Service } from './ServiceRow';

interface ServiceCustomerSectionProps {
  service: Service;
}

/**
 * Customer section — renders only the customer field that exists on
 * `Service` today (`customerName`). No invented customer detail.
 */
export function ServiceCustomerSection({ service }: ServiceCustomerSectionProps) {
  return (
    <div className="flex items-center justify-between gap-3 py-1.5">
      <span className="text-[11px] font-normal text-[var(--vania-colors-text-secondary,#a3aab8)]">مشتری</span>
      <span className="text-xs font-normal text-[var(--vania-colors-text-primary,#f5f6fa)]">
        {service.customerName}
      </span>
    </div>
  );
}
